/** @jsx jsx */
import { jsx } from '@emotion/react';

export default () => (
  <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.568 6.00798V4.03998C3.568 3.43998 3.856 3.18798 4.708 3.18798V2.08398H4.192C2.848 2.08398 2.32 2.50398 2.32 3.60798V6.09198C2.32 6.54798 2.164 6.72798 1.804 6.72798H1.432V7.86798H1.804C2.164 7.86798 2.32 8.04798 2.32 8.50398V10.976C2.32 12.092 2.848 12.512 4.192 12.512H4.708V11.408C3.856 11.408 3.568 11.156 3.568 10.556V8.58799C3.568 7.81998 3.34 7.44798 2.728 7.29198C3.34 7.14798 3.568 6.77598 3.568 6.00798Z"
      fill="#00939C"
    />
    <path
      d="M11.2012 6.72798C10.8412 6.72798 10.6852 6.54798 10.6852 6.09198V3.60798C10.6852 2.50398 10.1572 2.08398 8.81322 2.08398H8.29722V3.18798C9.14922 3.18798 9.43722 3.43998 9.43722 4.03998V6.00798C9.43722 6.77598 9.66522 7.14798 10.2772 7.29198C9.66522 7.44798 9.43722 7.81998 9.43722 8.58799V10.556C9.43722 11.156 9.14922 11.408 8.29722 11.408V12.512H8.81322C10.1572 12.512 10.6852 12.092 10.6852 10.976V8.50398C10.6852 8.04798 10.8412 7.86798 11.2012 7.86798H11.5732V6.72798H11.2012Z"
      fill="#00939C"
    />
  </svg>
);
